import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const legacyDashboardsAddRoute: InvariantJiraRoute = {
	name: 'legacy-dashboards-add',
	path: '(/secure/|/)AddPortalPage([!%]?[\\w]*).jspa',
};
